import React from 'react';

const RequestsNBues = () => {
    return (
        <div>
            
        </div>
    );
};

export default RequestsNBues;